module.exports = __webpack_public_path__ + "img/live6.69fa5d2e.jpg";